<div class="content-without-stepper-and-title">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div *ngIf="close">
        <p
          style="float: right; text-align: right; color: rgb(59, 137, 238)"
          (click)="continue()"
        >
          {{ copyService.copies.header_close }}
          <span
            id="clientless"
            (click)="continue()"
            class="icon-itaufonts_fechar"
          ></span>
        </p>
      </div>
      <div class="wrap">
        <div *ngIf="errorInfo.title && errorInfo.type === 'info'">
          <h1 id="headerTitle" [ngClass]="textsClass.tittle">
            {{ errorInfo.title }}
          </h1>
        </div>

        <!-- vista para el success -->
        <div 
          *ngIf="
            errorInfo.type !== 'zone-grey' && errorInfo.type !== 'bonding-async' && errorInfo.type !== 'warningDisplay'
          "
          [ngClass]="{'pco-rejection': errorInfo.type === 'pco_rejection'}"
        >
          <div class="img-container">
            <img
              [id]="'errorImage'"
              *ngIf="!isLottieImage && errorInfo.type !== 'zone-grey'"
              [src]="errorInfo.image"
              alt="Imágen del error"
              [ngClass]="{'pco-rejection__image': errorInfo.type === 'pco_rejection'}"/>
            <lottie-animation-view
              *ngIf="isLottieImage && errorInfo.type !== 'zone-grey'"
              [options]="errorInfo.image"
              [width]="200"
            ></lottie-animation-view>
          </div>
          <div
            [class.success]="
              errorInfo.type === 'success' ||
              errorInfo.type === 'successPrincipality'
            "
          >
            <h1
              id="title"
              [ngClass]="
                errorInfo.type === 'pco_rejection'
                ? 'pco-rejection__title'
                : textsClass.tittle
              "
              *ngIf="
                errorInfo.title &&
                errorInfo.type !== 'info' &&
                errorInfo.type !== 'zone-grey'
              "
              [innerHtml]="errorInfo.title"
            ></h1>
            <div class="specificInfoContainer" *ngIf="errorInfo.specificInfo">
              <strong> {{ errorInfo.specificInfo.title }}</strong>
              <p>{{ errorInfo.specificInfo.value }}</p>
            </div>
            <p
              id="description"
              [ngClass]="
                errorInfo.type === 'pco_rejection'
                ? 'pco-rejection__description'
                : textsClass.paragraph
              "
              *ngIf="
                errorInfo.description &&
                !isListDescription &&
                errorInfo.type !== 'zone-grey'
              "
              [innerHtml]="errorInfo.description"
              (click)="handleLoadCallToAction($event)"
            ></p>

            <div *ngIf="errorInfo.type === 'pco_rejection'">
              <p class="pco-rejection__title-solicitation">
                {{ copyService.copies.gray_zone_pco.solicitation_number }}
              </p>
              <p class="pco-rejection__solicitation-number">
                {{ codBizagi }}
              </p>
            </div>

            <div
              class="settings"
              id="settings"
              *ngIf="errorInfo.type === 'date-error'"
            >
              <vcl-link
                (click)="returnSelectionDate()"
                [label]="copyService.copies.error_back_to_edit_date"
                class="termsLink"
                [linkId]="'alliances'"
              >
              </vcl-link>
            </div>

            <div *ngIf="errorInfo.type === 'pco_rejection'" class="errorInfo pco-rejection__finish-btn">
              <app-controls
                id="errorBtns"
                [hasPrevious]="previous"
                [nextLabel]="errorInfo.buttonLabel"
                (next)="continue()"
              ></app-controls>
            </div>

          </div>

          <div *ngIf="errorInfo.type !== 'pco_rejection'" class="errorInfo">
            <app-controls
              id="errorBtns"
              [hasPrevious]="previous"
              [nextLabel]="errorInfo.buttonLabel"
              (next)="continue()"
            ></app-controls>
          </div>
        </div>
        
        <!-- vista para el bonding-async -->
        <div *ngIf="errorInfo.type === 'bonding-async'">
          <div class="imags-container">
            <img
              class="imags"
              id="'zone-greyImage'"
              *ngIf="!isLottieImage && errorInfo.type === 'bonding-async'"
              [src]="errorInfo.image"
              alt="Imágen del error"
            />
          </div>

          <div
            *ngIf="errorInfo.type === 'bonding-async'"
            [class.bonding-async]="errorInfo.type === 'bonding-async'"
          >
            <h1
              class="bonding-async"
              [ngClass]="textsClass.tittle"
              id="title-bonding-async"
              *ngIf="
                errorInfo.title &&
                errorInfo.type !== 'info' &&
                errorInfo.type === 'bonding-async'
              "
              [innerHtml]="errorInfo.title"
            ></h1>

            <!-- <div class="specificInfoContainer" *ngIf="errorInfo.specificInfo && errorInfo.type !== 'bonding-async'">
              <strong> {{ errorInfo.specificInfo.title }}</strong>
              <p>{{ errorInfo.specificInfo.value }}</p>
            </div> -->

            <div class="specificInfoContainer" *ngIf="errorInfo.specificInfo">
              <div *ngIf="errorInfo && errorInfo.type === 'bonding-async'">
                <strong> {{ errorInfo.specificInfo.title }}</strong>
                <p>{{ errorInfo.specificInfo.value }}</p>
              </div>
            </div>
            <p
              class="description-bonding-async"
              [ngClass]="textsClass.paragraph"
              id="description-bonding-async"
              *ngIf="
                errorInfo.description &&
                !isListDescription &&
                errorInfo.type === 'bonding-async'
              "
              [innerHtml]="errorInfo.description"
              (click)="handleLoadCallToAction($event)"
            ></p>

            <div class="botton-boanding">
              <app-controls
                id="errorBtns"
                [hasPrevious]="previous"
                [nextLabel]="errorInfo.buttonLabel"
                (next)="continue()"
              >
              </app-controls>
            </div>
          </div>
        </div>

        <!-- vista para el zone-grey -->
        <div *ngIf="errorInfo.type === 'zone-grey'">
          <div class="images-container">
            <img
              class="images"
              id="'zone-greyImage'"
              *ngIf="!isLottieImage && errorInfo.type === 'zone-grey'"
              [src]="errorInfo.image"
              alt="Imágen del error"
            />
          </div>
          <div [class.zone-grey]="errorInfo.type === 'zone-grey'">
            <h1
              class="zone-grey"
              [ngClass]="textsClass.tittle"
              id="title-zone-grey"
              *ngIf="
                errorInfo.title &&
                errorInfo.type !== 'info' &&
                errorInfo.type === 'zone-grey'
              "
              [innerHtml]="errorInfo.title"
            ></h1>
            <div
              class="specificInfoContainer"
              *ngIf="errorInfo.specificInfo && errorInfo.type !== 'zone-grey'"
            >
              <strong> {{ errorInfo.specificInfo.title }}</strong>
              <p>{{ errorInfo.specificInfo.value }}</p>
            </div>
            <p
              [ngClass]="textsClass.paragraph"
              id="description-zone-grey"
              *ngIf="
                errorInfo.description &&
                !isListDescription &&
                errorInfo.type === 'zone-grey'
              "
              [innerHtml]="errorInfo.description"
              (click)="handleLoadCallToAction($event)"
            ></p>
          </div>
          <div class="specificInfoContainer" *ngIf="errorInfo.specificInfo">
            <div *ngIf="errorInfo && errorInfo.type === 'zone-grey'">
              <strong> {{ errorInfo.specificInfo.title }}</strong>
              <p>{{ errorInfo.specificInfo.value }}</p>
            </div>

            <div class="button">
              <app-controls
                id="errorBtns"
                [hasPrevious]="previous"
                [nextLabel]="errorInfo.buttonLabel"
                (next)="continue()"
              >
              </app-controls>
            </div>
          </div>

          <ul
            class="description"
            id="descriptionList"
            *ngIf="errorInfo.description && isListDescription"
          >
            <vcl-list>
              <li *ngFor="let item of errorInfo.description" vclListSimple>
                <em
                  [id]="'chatEnviadoIcon'"
                  class="bullet icon-itaufonts_chat_enviado"
                ></em>
                <vcl-list-text>
                  {{ item }}
                </vcl-list-text>
              </li>
            </vcl-list>
          </ul>
          <div
            class="offices"
            id="offices"
            *ngIf="errorInfo.showLinkOffices && errorInfo.type !== 'zone-grey'"
          >
            <em [id]="'agencyIcon'" class="icon-itaufonts_agencia"></em>
            <vcl-link
              [linkId]="'officeslink'"
              (click)="goToOffices()"
              [a11yLabel]="copyService.copies.error_link_offices_label"
              [label]="copyService.copies.error_link_offices_label"
            >
            </vcl-link>
            <em [id]="'setaRightIcon'" class="icon-itaufonts_seta_right"></em>
          </div>
          <div
            class="settings"
            id="settings"
            *ngIf="errorInfo.showLinkSettings && errorInfo.type !== 'zone-grey'"
          >
            <vcl-link
              [linkId]="'settingslink'"
              (click)="goToSettingsDevice()"
              [a11yLabel]="copyService.copies.error_link_settings_label"
              [label]="copyService.copies.error_link_settings_label"
            >
            </vcl-link>
          </div>
          <div
            class="settings"
            id="settings"
            *ngIf="errorInfo.type === 'date-error'"
          >
            <vcl-link
              (click)="returnSelectionDate()"
              [label]="copyService.copies.error_back_to_edit_date"
              class="termsLink"
              [linkId]="'alliances'"
            >
            </vcl-link>
          </div>
        </div>

         <!-- vista para el warningDisplay -->
         <div *ngIf="errorInfo.type === 'warningDisplay'">
          <div class="images-container">
            <img
              class="images"
              id="'warningDisplayImage'"
              *ngIf="!isLottieImage && errorInfo.type === 'warningDisplay'"
              [src]="errorInfo.image"
              alt="Imágen del error"
            />
          </div>
          <div [class.zone-grey]="errorInfo.type === 'warningDisplay'">
            <h1
              class="warningDisplay"
              [ngClass]="textsClass.tittle"
              id="title-warningDisplay"
              *ngIf="
                errorInfo.title &&
                errorInfo.type !== 'info' &&
                errorInfo.type === 'warningDisplay'
              "
              [innerHtml]="errorInfo.title"
            ></h1>
            <div
              class="specificInfoContainer"
              *ngIf="errorInfo.specificInfo && errorInfo.type !== 'warningDisplay'"
            >
              <strong> {{ errorInfo.specificInfo.title }}</strong>
              <p>{{ errorInfo.specificInfo.value }}</p>
            </div>
            <p
              [ngClass]="textsClass.paragraph"
              id="description-warningDisplay"
              *ngIf="
                errorInfo.description &&
                !isListDescription &&
                errorInfo.type === 'warningDisplay'
              "
              [innerHtml]="errorInfo.description"
              (click)="handleLoadCallToAction($event)"
            ></p>
          </div>
          <div class="button">
            <app-controls
              id="errorBtns"
              [hasPrevious]="previous"
              [nextLabel]="errorInfo.buttonLabel"
              (next)="continue()"
            >
            </app-controls>
          </div>

          <ul
            class="description"
            id="descriptionList"
            *ngIf="errorInfo.description && isListDescription"
          >
            <vcl-list>
              <li *ngFor="let item of errorInfo.description" vclListSimple>
                <em
                  [id]="'chatEnviadoIcon'"
                  class="bullet icon-itaufonts_chat_enviado"
                ></em>
                <vcl-list-text>
                  {{ item }}
                </vcl-list-text>
              </li>
            </vcl-list>
          </ul>
          <div
            class="offices"
            id="offices"
            *ngIf="errorInfo.showLinkOffices && errorInfo.type !== 'zone-grey'"
          >
            <em [id]="'agencyIcon'" class="icon-itaufonts_agencia"></em>
            <vcl-link
              [linkId]="'officeslink'"
              (click)="goToOffices()"
              [a11yLabel]="copyService.copies.error_link_offices_label"
              [label]="copyService.copies.error_link_offices_label"
            >
            </vcl-link>
            <em [id]="'setaRightIcon'" class="icon-itaufonts_seta_right"></em>
          </div>
          
        </div>
        
      </div>
    </div>
  </div>
</div>
